const ConfigApp = {
  accessToken: "accessToken",
  refreshToken: "refreshToken",

  userInfo: "userInfo",
};

export default ConfigApp;
